import { Dispatch, FC, SetStateAction } from "react";

import Button from "../BaseComponents/Button";
import Modal from "../BaseComponents/Modal";
import { Col, Row } from "../BaseComponents/Flex";

interface ErrorModalProps {
  title?: string;
  message?: string;
  acceptButtonText?: string;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  rejectButtonText?: string;
  children: React.ReactNode;
}

const ErrorModal: FC<ErrorModalProps> = ({
  title,
  message,
  acceptButtonText,
  setIsOpen,
  children,
}) => {
  const onAcceptClick = async () => {
    setIsOpen(false);
  };

  return (
    <Modal
      info={message}
      maxWidth={450}
      setIsOpen={setIsOpen}
      title={title}
      isClosable={false}
    >
      <Row justifyContent='center' isResponsive noMargin>
        {children}
      </Row>
      <Row justifyContent='center' isResponsive noMargin>
        <Col size={0.3}>
          <Button
            height='40px'
            margin='25px 0 0 0'
            onClick={onAcceptClick}
            text={acceptButtonText}
          />
        </Col>
      </Row>
    </Modal>
  );
};

export default ErrorModal;
